<template>
    <div 
        class="info-button" 
        :class="{ 'disabled': !wikiUrl }"
        @click="handleClick"
        :title="wikiUrl ? 'Открыть документацию' : 'Документация недоступна'"
    >
        <div class="icon-wrapper">
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"
            >
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="16" x2="12" y2="12"/>
                <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    wikiUrl: {
        type: String,
        default: ''
    }
});

const handleClick = () => {
    if (props.wikiUrl) {
        window.open(props.wikiUrl, '_blank');
    }
};
</script>

<style scoped>
.info-button {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        .icon-wrapper {
            transform: scale(1.05);
            box-shadow: 0 4px 15px rgba(67, 97, 238, 0.4);
        }
    }
}

.icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #4361ee;
    border-radius: 50%;
    color: white;
    box-shadow: 0 2px 10px rgba(67, 97, 238, 0.3);
    animation: pulse 2s infinite;
    transition: all 0.3s ease;
}

.info-button.disabled {
    pointer-events: none;

    .icon-wrapper {
        background: #94a3b8;
        box-shadow: none;
        animation: none;
    }
}

@keyframes pulse {
    0% {
        transform: scale(1);
        box-shadow: 0 2px 10px rgba(67, 97, 238, 0.3);
    }
    50% {
        transform: scale(1.05);
        box-shadow: 0 4px 15px rgba(67, 97, 238, 0.4);
    }
    100% {
        transform: scale(1);
        box-shadow: 0 2px 10px rgba(67, 97, 238, 0.3);
    }
}
</style> 
